import React from "react"
import { useOutlet } from "react-router-dom"

export const Products = () => {
  const outlet = useOutlet()

  return <>{outlet}</>
}
